// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"9c346d15","453":"419a5d54","646":"104b223a","803":"d6b7dbf5"}[chunkId] + ".chunk.js";
};